<template>
    <b-container>
        <transition name="fade">
            <div v-if="performingRequest" class="loading">
                <p>Signing In..</p>
            </div>
        </transition>

        <!-- Login modal -->
        <b-modal no-fade size="l" id="modal-login" title="Sign In" ok-title="Sign In" @ok="login()" @cancel="cancelLogin()">
                Login to send a message 
                <b-input-group prepend="Email" class="mt-3">
                    <b-form-input v-model="email"></b-form-input>
                </b-input-group>
                <b-input-group prepend="Password" class="mt-3">
                    <b-form-input type="password"  v-model="password"></b-form-input>
                </b-input-group>

        </b-modal>

        <!-- Must log in message -->
        <b-row v-if="!isLoggedIn" style="margin-top:20px">
            <b-col>
                <h4>You must be logged in to send a message</h4>
            </b-col>
        </b-row>

        <!-- Invalid login -->
        <b-row v-if="errorMsg" style="margin-top:20px; color:red">
            <b-col>
                <h4>{{errorMsg}}</h4>
                <br>
                <b-button variant="info" v-b-modal.modal-login>Try Again</b-button>
            </b-col>
        </b-row>

        <!-- User has logged in -->
        <b-row v-if="isLoggedIn" style="margin-top:20px">
            <b-col>
                <h6>Type your message for {{getReceiverName}}</h6>
                <sendmessage  :receiverId="getReceiverId" :receiverName="getReceiverName" />
            </b-col>
        </b-row>

        
    </b-container>
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    const fb = require('../firebaseConfig.js')
    import Sendmessage from './Sendmessage'
    export default {
        components: {
            Sendmessage
            },
        computed: {
            ...mapState(['userProfile', 'currentUser']),
            getReceiverId(){
                var rxId = ''
                if (this.currentUser.uid==this.order.pubid) rxId = this.order.brewerid
                else rxId = this.order.pubid
                return rxId

            },
            getReceiverName(){
                var rxName = ''
                if (this.currentUser.uid==this.order.pubid) rxName = this.order.brewer
                else rxName = this.order.pub
                return rxName

            },
        },

        data() {
            return {
                arrayDefaultMessages:[],
                email:'',
                password:'',
                isLoggedIn:false,
                performingRequest:false,
                errorMsg:'',
                suborderid:'',
                order:{},

            }
        },

        methods:{
            //Login user
            login(){
                this.performingRequest = true
                console.log("Signing in ")
                this.errorMsg = ""
                fb.auth.signInWithEmailAndPassword(this.email, this.password).then(user => {
                    this.$store.commit('setCurrentUser', user.user)
                    
                    this.getOrder()
                        
                }).catch(err => {
                    this.isLoggedIn=false
                    console.log(err)
                    this.performingRequest = false
                    this.errorMsg = err.message
                })
            },

            //Login cancelled pressed
            cancelLogin(){
                console.log("Login cancelled")
                this.errorMsg="You must be logged on to send a message"
            },

            //Get the order
            getOrder(){
                var fbref = fb.ordersCollection
                console.log("Getting order")
                fbref.where('suborderid', '==', this.suborderid).get().then(docs => {
                    this.loadingPage=false
                    docs.forEach(doc => {
                        let theOrderData = doc.data()
                        console.log("Order = ")
                        console.log(theOrderData)
                        this.order = theOrderData
                        this.isLoggedIn=true
                        this.performingRequest = false

                    })
                }).then(res => {
                })
                .catch(err => {
                console.log(err)
                })
            },

        },

        mounted(){
            //Get order id
            this.suborderid = this.$route.params.orderid 
            if (this.suborderid ){
                console.log("Order id = " + this.suborderid)
            }

            //Check if user is logged in. If not, show login window
            if(this.currentUser){
                this.isLoggedIn=true
                this.getOrder()
            }
            else{
                this.$bvModal.show("modal-login")
            }
        },
        
    }
</script>